import React from 'react';
import { TextField, styled } from '@mui/material';

const StyledTextField = styled(TextField)(({ theme }) => ({
  width: '100%',
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(4),
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
    backgroundColor: '#1D1D1D',
    backdropFilter: 'blur(10px)',
    '& fieldset': {
      borderColor: 'rgba(255, 255, 255, 0.3)',
      borderWidth: '1px',
    },
    '&:hover fieldset': {
      borderColor: 'rgba(255, 255, 255, 0.3)',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'rgba(255, 255, 255, 0.3)',
      borderWidth: '1px',
      borderBottomColor: '#fff',
      borderBottomWidth: '1px',
    },
  },
  '& .MuiInputLabel-root': {
    color: 'rgba(255, 255, 255, 0.7)',
  },
  '& .MuiInputBase-input': {
    color: '#fff',
    caretColor: '#fff',
    padding: '16px 14px',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'rgba(255, 255, 255, 0.3)',
  },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: 'rgba(255, 255, 255, 0.3)',
    borderBottomColor: '#fff',
    borderBottomWidth: '1px',
  },
}));

const CustomTextField = ({ label, value, onChange, type = 'text', inputProps, multiline = false, rows = 1, ...props }) => {
  return (
    <StyledTextField
      label={label}
      value={value}
      onChange={onChange}
      variant="outlined"
      type={type}
      fullWidth
      multiline={multiline}
      rows={rows}
      inputProps={inputProps}
      {...props}
    />
  );
};

export default CustomTextField;
